import { enableProdMode, provideZoneChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";

import { configurationToken, Configuration, setEnvironment } from "./configuration";
import { loadConfiguration } from "./configuration-loader";

// SECURITY WARNING: The following code causes an Open Redirect vulnerability (snyk code test).
// This redirect is required for QuickSight iframe integration. "Linking" from a QuickSight report to a specific certificate,
// the app loads inside the iframe. This code ensures the app loads in the top window instead.
// medium-risk: If the URL is manipulated by an attacker, it could redirect the parent window to a malicious site.
// Note: Added 2026-01-15. Expectation is to remove this workaround in 2026 if/when QuickSight is replaced by Metabase.
if (window.self !== window.top) {
    //if we're being loaded in an frame, such as from quicksight, redirect the parent window to the same url
    window.parent.location.href = window.location.href;
}

loadConfiguration()
    .then((configuration: Configuration) => {
        setEnvironment(configuration);
        if (configuration.production) {
            enableProdMode();
        }

        return platformBrowserDynamic([{ provide: configurationToken, useValue: configuration }]).bootstrapModule(
            AppModule,
            { applicationProviders: [provideZoneChangeDetection()] },
        );
    })
    .catch((error) => console.error(error));
